module.exports = __webpack_public_path__ + "img/ex-6.60dfc62f.svg";